import * as React from 'react';
import { clickAskProfessional } from '../../../utils/events';

export const NoAnswerQuestionItem = () => (
  // tslint:disable:max-line-length
  <React.Fragment>
    Наш Помощник развивается и постепенно будет наполняться всё большим количеством статей. А пока, вы можете <a
    onClick={clickAskProfessional} href="https://www.cian.ru/add-vopros/">задать свой вопрос
    профессионалам</a> рынка{' '}
    или <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSchgoXzaxnvx5obzuLB9cyucYPhha1KKvGsky-aX-TmZybndQ/viewform">оставить
    ваш отзыв о Помощнике</a>.
  </React.Fragment>
)

